const deleteFamilyMemberById = (familyMemberId: string) => {
  return;
};

const createFamilyMember = () => {
  return;
};

export const familyMembers = {
  deleteFamilyMemberById,
  createFamilyMember
};
